<template>
  <vue-modal no-close ref="modal">
    <template v-slot:header>
      <div></div>
    </template>
    <template v-slot:default>
      <div v-if="loading">
        <div class="loading-shade"></div>
        <pre-loader></pre-loader>
      </div>

      <div class="container-terms-modal">
        <div class="label">Marketing Preferences:</div>

        <div class="field-wr">
          <div><i>I Consent to receive marketing from Geoff Banks Online for Real Sports Events via:</i></div>
          <div class="flex-list">
            <vue-checkbox 
              class="checkbox-input"
              v-model="model.realSportsMarketing.byEmail"
              name="cbx-modal-real-email"
              description="Email"
              label-class="w-100"
            >
              <div class="cbx-label">Email</div>
            </vue-checkbox>

            <vue-checkbox 
              class="checkbox-input"
              v-model="model.realSportsMarketing.bySms"
              name="cbx-modal-real-sms"
              description="SMS"
              label-class="w-100"
            >
              <div class="cbx-label">SMS</div>
            </vue-checkbox>
          </div>

          <div><i>I Consent to receive marketing from Geoff Banks Online for Virtual Sports Events via:</i></div>
          <div class="max-width-field flex-list">
            <vue-checkbox 
              class="checkbox-input"
              v-model="model.virtualSportsMarketing.byEmail"
              name="cbx-modal-virtual-email"
              description="Email"
              label-class="w-100"
            >
              <div class="cbx-label">Email</div>
            </vue-checkbox>

            <vue-checkbox 
              class="checkbox-input"
              v-model="model.virtualSportsMarketing.bySms"
              name="cbx-modal-virtual-sms"
              description="SMS"
              label-class="w-100"
            >
              <div class="cbx-label">SMS</div>
            </vue-checkbox>
          </div>
        </div>
      </div>

      <vue-button 
        type="button"
        @click="submitForm"
        :cls="'main'">Submit</vue-button>

    </template>
  </vue-modal>
</template>

<script>
import { mapGetters } from "vuex";
import PreLoader from "@/components/UI/PreLoader";
import VueModal from "@/components/UI/VueModal";
import VueButton from "@/components/UI/VueButton";
import VueCheckbox from "@/components/UI/VueCheckbox";

export default {
  name: "MarketingPreferencesModal",
  components: {
    VueModal,
    VueButton,
    VueCheckbox,
    PreLoader
  },
  data: () => {
    return {
      
      loading: false,
      model: {
        realSportsMarketing: {
          byEmail: false,
          bySms: false,
        },
        virtualSportsMarketing: {
          byEmail: false,
          bySms: false,
        }
      }
    }
  },
  computed: {
    ...mapGetters(['USER']),
  },
  watch: {
    'USER.isMarketingModal'() {
      this.initPopupState()
    },
  },
  mounted() {
    this.initPopupState()
  },
  methods:{
    initPopupState() {
      if (this.USER?.isMarketingModal) {
        this.$refs.modal.open()
      }
      else (
        this.$refs.modal.close()
      )
    },
    submitForm() {
      this.loading = true;
      this.API.postMarketingModal({...this.model})
        .then((data) => {
          if (data?.isMarketingModalSubmitted) {
            // set updated settings
            this.$store.dispatch('SET_USER_DATA', {
              preferences: {
                ...this.USER.preferences,
                realSportsMarketing: data.realSportsMarketing,
                virtualSportsMarketing: data.virtualSportsMarketing
              }
            }).then(() => {
              this.API.getIsShowMarketingModal()
                .then((data) => {
                  this.$store.dispatch('SET_USER_DATA', {
                    isMarketingModal: data.isMarketingModalSubmitted,
                  }).then(() => {
                    this.$router.push({name: 'home'})
                  })
                })
                .catch(err => {
                  console.log('getIsShowMarketingModal err', err)
                  this.$toast.error('Something went wrong. Please try again later')
                })
                .finally(() => {
                  this.loading = false
                })
            })

          }
          else {
            this.loading = false
            this.$toast.error('Something went wrong. Please try again later')
          }
        })
        .catch((err) => {
          console.log('postMarketingModal', err)
          this.$toast.error('Something went wrong. Please try again later')
          this.loading = false
        })
      
     
    },

    reloadUserPreferences() {
      return this.API.getUserPreferencesAzure()
        .then(data => {
          this.$store.dispatch('SET_USER_DATA', {
            preferences:  {
              carousel: data.carousel,
              oddFormat: data.oddFormat,
              sortRacing: data.sortRacing,
              carouselRegion: data.carouselRegion,
              realSportsMarketing: data.realSportsMarketing,
              virtualSportsMarketing: data.virtualSportsMarketing
            }
          })
        })
    }
    
  }
}
</script>

<style scoped lang="scss">
  .content{
    max-width: 400px;
  }

  .container-survey,
  .container-terms-modal {
    margin: 0 0 1rem;
    max-width: 60vw;
    @media only screen and (max-width: 1024px){
      max-width: unset;
    }

    .survey-item {
      display: grid;
      grid-template-columns: 80% 1fr 1fr;
      align-items: center;
      text-align: center;
      margin-bottom: 1rem;

      >div:first-child {
        text-align: left;
      }

      &.title {
        text-transform: uppercase;
      }
    }

    .result {
      margin-bottom: 1rem;
    }
  }

  .flex-list {
    display: flex;
    gap: 2rem;
  }
</style>